// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { shardeumSphinx as _shardeumSphinx } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the shardeumSphinx chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 8082
 * Chain Name: Shardeum Sphinx
 * Default Block Explorer: https://explorer-sphinx.shardeum.org
 * Default RPC URL: https://sphinx.shardeum.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { shardeumSphinx } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: shardeumSphinx,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const shardeumSphinx = createCommon({
	..._shardeumSphinx,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
